import { Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ColorScheme } from '../../Themes/ColorScheme';

const PagingIndicator = ({ currentPage, totalPages, onPageChange, hideTotalPagesCount, maxButtons = 10 }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // md = 900px by default

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: isDesktop ? 'row' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10px 0',
    gap: '10px',
  };

  const buttonStyle = {
    margin: '0 0px',
    height: '30px',
    minWidth: '30px',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    backgroundColor: ColorScheme.secondary,
    border: "1px solid " + ColorScheme.buttonPrimary,
    color: ColorScheme.primary,
    borderRadius: '4px',
    disabled: {
      opacity: 0.3,
      cursor: 'not-allowed',
    },
  };

  // Calculate page numbers to show
  const getPageNumbers = () => {
    let start = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    let end = start + maxButtons - 1;
    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxButtons + 1);
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };
  
  return (
    <div style={containerStyle}>
      <button
        onClick={handlePrevious}
        disabled={currentPage === 1}
        style={currentPage === 1 ? { ...buttonStyle, ...buttonStyle.disabled } : buttonStyle}
      >
         <Typography>
        {t("common.previous")}
       </Typography>
      </button>
      {isDesktop ? (
        <>
          {getPageNumbers().map(page => (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              disabled={page === currentPage}
              style={page === currentPage
                ? { ...buttonStyle, backgroundColor: ColorScheme.primary, color: ColorScheme.secondary, fontWeight: 'bold' }
                : buttonStyle}
            >
              {page}
            </button>
          ))}
        </>
      ) : (
        <Typography sx={{ color: ColorScheme.textSecondary, fontWeight: 'bold' }}>
          {t("common.page") + " " + currentPage + (!hideTotalPagesCount ? (" / " + totalPages) : "") }
        </Typography>
      )}
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        style={currentPage === totalPages ? { ...buttonStyle, ...buttonStyle.disabled } : buttonStyle}
      >
       <Typography>
        {t("common.next")}
        </Typography>
      </button>
    </div>
  );
};

PagingIndicator.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  hideTotalPagesCount: PropTypes.bool,
  maxButtons: PropTypes.number,
};

export default PagingIndicator;